module.exports = __webpack_public_path__ + "da83b3ada69add3f2799e758e3bbdb5e.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/nl1.pdf
// module id = 931
// module chunks = 3